export const VARIANTS = {
  PROGRESS: "progress",
  PLAN: "plan",
  HANDLER: "handler",
  HANDLER_DRAFT: "handlerDraft",
  HANDLER_PRODUCTION: "handlerProduction"
};